
import Loading from 'vux/src/components/loading/index.vue'

import CommonFooter from '@/components/el-common-footer'
import LoadingToast from '@/components/el-loading-toast'
import FeedbackPopup from '@/components/el-feedback-popup'
import FullLoading from '@/components/el-full-loading'
export default {
data() {
return {
show_feedback: false,
is_pc_site: undefined,
}
},
components: {Loading, CommonFooter, LoadingToast, FeedbackPopup, FullLoading},
computed: {
is_loading() {


return this.$store.state.app.is_loading || (this.is_initial_loading && !this.is_frequent_view)
},
is_initial_loading() {
return this.$store.state.app.is_initial_loading
},
is_prerelease() {
return this.$store.state.app.is_prerelease
},
loading_toast_text() {
return this.$store.state.app.loading_toast_text
},
loading_text() {
const type = typeof this.$store.state.app.is_loading
if (type == 'string') {
return this.$store.state.app.is_loading
}
return ''
},
is_frequent_view() {

const isDetail = location.href.match(/(notification|punch_in|homework)\/\d+/)

const isPromote = location.href.match(/promote/)
return isDetail || isPromote
},
show_skeleton() {
return this.is_initial_loading && this.is_frequent_view
},
overlayed() {
return this.$store.state.app.overlayed
}
},
watch: {
$route(a, b) {
if (a.meta.feedback) {
this.show_feedback = true
} else {
this.show_feedback = false
}

this.is_pc_site = location.href.indexOf('/pc') >= 0
}
},
methods: {
hideLoadingToast() {
this.$store.dispatch('toastLoading')
}
},
mounted() {
console.log('NODE_ENV', process.env.NODE_ENV, this.is_prerelease, location.origin)
this.is_pc_site = location.href.indexOf('/pc') >= 0


document.addEventListener("touchstart", function(){}, true);


if (document.body.classList.contains('skeleton')) {
document.body.classList.remove('skeleton')
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue